import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraEntityCell } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { eventDescription, useEvent } from './eventHooks';
export function TouchpointEventCell({ eventId, title }) {
    const event = useEvent(eventId);
    if (!eventId) return '—';
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": Testids.pursuitCustomer.eventCell,
        children: /*#__PURE__*/ _jsx(SpecraEntityCell, {
            title: event.data?.event?.title || title || 'Event',
            description: event.data?.event ? eventDescription(event.data.event) : undefined
        })
    });
}
